(function AllInclusivePropertiesProcessor($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload('AllInclusiveProperties/processor', function onload()
		{
			var $processor = $('div.processor-content');

			Adzuki.Ajax.get($processor.data('request'))
			.then(function processed(data) {
				if (data.redirect) {
					window.location.replace(data.redirect);
				} else {
					alert('Unknown error');
					window.history.back();
				}
			});
		});
	});

}(jQuery, window.Adzuki || {}));